import '@fortawesome/fontawesome-pro/scss/fontawesome.scss';
import '@fortawesome/fontawesome-pro/scss/regular.scss';
import '@fortawesome/fontawesome-pro/scss/solid.scss';
import angular                  from 'angular';
import animate                  from 'angular-animate';
import 'angular-bootstrap-datetimepicker/src/js/datetimepicker';
import 'angular-bootstrap-datetimepicker/src/js/datetimepicker.templates';
import 'angular-datatables';
import 'angular-file-saver/dist/angular-file-saver.bundle';
import 'angular-filter';
import storage                  from 'angular-local-storage';
import moment                   from 'angular-moment';
import 'angular-recaptcha';
import sanitize                 from 'angular-sanitize';
import 'angular-slimscroll';
import toastr                   from 'angular-toastr';
import 'angular-toastr/dist/angular-toastr.css';
import bootstrap                from 'angular-ui-bootstrap';
import uiMask                   from 'angular-ui-mask';
import router                   from 'angular-ui-router';
import 'angular-underscore';
import 'angular-uuid';
import 'bootstrap/dist/css/bootstrap.css';
import 'clone-deep';
import 'datatables.net';
import 'datatables.net-bs/css/dataTables.bootstrap.css';
import 'datatables.net-buttons-bs';
import 'datatables.net-buttons-bs/css/buttons.bootstrap.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import 'datatables.net-buttons/js/dataTables.buttons';
import 'datatables.net-colreorder-bs/css/colReorder.bootstrap.css';
import 'datatables.net-colreorder/js/dataTables.colReorder';
import 'datatables.net-fixedcolumns-bs/css/fixedColumns.bootstrap.css';
import 'datatables.net-fixedcolumns/js/dataTables.fixedColumns';
import 'datatables.net-fixedheader-bs/css/fixedHeader.bootstrap.css';
import 'datatables.net-fixedheader/js/dataTables.fixedHeader';
import 'jquery';
import 'jstree/dist/jstree';
import 'jstree/dist/themes/default/style.css';
import 'mdn-polyfills/Array.prototype.find';
import 'metismenu';
import 'moment-duration-format';
import 'ng-csv/build/ng-csv';
import fileUpload               from 'ng-file-upload';
import 'ng-js-tree/dist/ngJsTree';
import ngclipboard              from 'ngclipboard/dist/ngclipboard';
import 'pusher-angular';
import Raven                    from 'raven-js';
import RavenAngular             from 'raven-js/plugins/angular';
import restangular              from 'restangular';
import satellizer               from 'satellizer';
import 'showdown';
import select                   from 'ui-select';
import 'underscore';
import 'vjs-video';
import '../theme/style.scss';
import config                   from './config';
import {load as loadConstants}  from './constants/loader';
import {load as loadDirectives} from './directives/loader';
import {load as loadEndpoints}  from './endpoints/loader';
import {load as loadFactories}  from './factories/loader';
import {load as loadFilters}    from './filters/loader';
import run                      from './run';
import {load as loadServices}   from './services/loader';

Raven
	.config(`https://${process.env.SENTRY_KEY}@sentry.io/${process.env.SENTRY_PROJECT}`, {
		environment: process.env.SENTRY_ENVIRONMENT,
	})
	.addPlugin(RavenAngular, angular)
	.install();

/*
 * Uncomment the following to enable HTML5 / Flash buttons for Excel and PDF, but significantly increase the build size.
 *
 * //import 'datatables.net-buttons/js/buttons.flash';
 * //import 'imports-loader?this=>window!pdfmake/build/vfs_fonts.js';
 * //import 'jszip/dist/jszip';
 * //import 'jszip/vendor/FileSaver';
 * //import 'pdfmake/build/pdfmake.js';
 *
 * npm install --save pdfmake "^0.1.54"
 * npm install --save jszip "^3.1.4"
 */

const app = angular.module(
	'app', [
		router,
		satellizer,
		restangular,
		animate,
		bootstrap,
		moment,
		sanitize,
		select,
		toastr,
		storage,
		ngclipboard,
		fileUpload,
		uiMask,
		// Because of the way the code was written, these modules are required to be included as a string
		'pusher-angular',
		'angular.filter',
		'datatables',
		'datatables.bootstrap',
		'datatables.buttons',
		'underscore',
		'ngSlimScroll',
		'vjs.video',
		'ui.bootstrap.datetimepicker',
		'angular-uuid',
		'vcRecaptcha',
		'ngCsv',
		'ngFileSaver',
		'ngJsTree',
		'ngRaven',
	]);

app.config(config);

loadConstants(app);
loadDirectives(app);
loadFactories(app);
loadFilters(app);
loadServices(app);
loadEndpoints(app);

app.run(run);

export default app;



// WEBPACK FOOTER //
// ./src/js/app.js